import ConfigurationStatusModalContent from './ConfigurationStatusModalContent';
import {
  TProductConfigResponse,
  CONFIGURATION_STATUS_MODAL_VALUES
} from '../../../../types/product.configuration.types';
import { NudosGenericModal, NudosModalContent } from '../../../NudosComponents';

import './ConfigurationStatusModal.scss';

const ConfigurationStatusModal = ({
  type,
  configurationData,
  closeModalCallback,
  updateDataCallback,
  orderId,
  logisticServiceId,
  productUuid
}: {
  type: CONFIGURATION_STATUS_MODAL_VALUES;
  configurationData: TProductConfigResponse;
  closeModalCallback: () => void;
  updateDataCallback: () => Promise<void>;
  orderId?: string | null;
  logisticServiceId?: number;
  productUuid?: string;
}) => {
  const getDataByType = () => {
    switch (type) {
      case CONFIGURATION_STATUS_MODAL_VALUES.COMPLETED:
        return {
          title: `Marcar configuración como completada`
        };
      default:
        return {
          title: `Marcar configuración como no completada`
        };
    }
  };

  const getModalHeight = () => {
    const isCompletedModal = type === CONFIGURATION_STATUS_MODAL_VALUES.COMPLETED;
    return isCompletedModal ? '426px' : '450px';
  };

  const { title } = getDataByType();

  return (
    <div className="configurationStatusModal">
      <NudosGenericModal
        closeModalCallback={() => closeModalCallback()}
        clickOutsideCallback={() => closeModalCallback()}
        modalContent={
          <NudosModalContent
            customWidth="580px"
            customHeight={getModalHeight()}
            toCloseModal={closeModalCallback}
            modalContentTitle={title}
            CustomModalComponent={
              <ConfigurationStatusModalContent
                type={type}
                closeModalCallback={closeModalCallback}
                updateDataCallback={updateDataCallback}
                configurationData={configurationData}
                orderId={orderId}
                logisticServiceId={logisticServiceId}
                productUuid={productUuid}
              />
            }
          />
        }
      />
    </div>
  );
};

export default ConfigurationStatusModal;
